// src/app/services/coaching-listar-usuario.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CoachingListarUsuarioService {
  private apiUrl = 'https://apisozarusac.com/Coaching/api/usuarios-asesores/';

  constructor(private http: HttpClient) {}

  obtenerUsuariosAsesores(): Observable<any> {
    return this.http.get<any>(this.apiUrl);
  }
}
